module.exports = __webpack_public_path__ + "img/samurai.b4442c95.png";